import { formatVND } from '@Utils/helpers';
import { SHIPPING_COMPANY } from '@Lib/constant';
import { getOrderStatusIcon } from '@Utils/orderStatusIcons';

export const getWarehouseName = (warehouse) => {
  if (!warehouse) {
    return '';
  }

  if (typeof warehouse === 'object') {
    return warehouse.warehouse_name || warehouse.name || warehouse.label || warehouse.code || '';
  }

  return String(warehouse).trim();
};

export const getOrderProductWarehouseCode = (item) => {
  const warehouseLabel =
    item?.pivot?.warehouse_code ||
    item?.warehouse_code ||
    item?.pivot?.warehouse_name ||
    item?.warehouse_name;

  return warehouseLabel ? String(warehouseLabel).trim().toUpperCase() : '';
};

export const getOrderProductWarehouseColor = (item) =>
  item?.pivot?.warehouse_color || item?.warehouse_color || item?.warehouse?.color || null;

export const getOrderProductDisplayName = (item) => {
  const warehouseLabel = getOrderProductWarehouseCode(item);
  const productName = item?.name || '';

  return warehouseLabel ? `[${warehouseLabel}] ${productName}` : productName;
};

export const getCategoryName = (slug) => {
  const objCategory = {
    quan_ao: 'Quần áo nội địa',
    giay_dep: 'Giày dép nội địa',
    tui_xach: 'Túi xách nội địa',
    phu_kien: 'Phụ kiện nội địa',
    quan_ao_thuong_hieu: 'Quần áo thương hiệu',
    giay_dep_thuong_hieu: 'Giày dép thương hiệu',
    tui_xach_thuong_hieu: 'Túi xách thương hiệu',
    phu_kien_thuong_hieu: 'Phụ kiện thương hiệu',
    thoi_trang_thiet_ke: 'Thời trang thiết kế',
  };
  return slug ? objCategory[slug] : '';
};

export const getShippingCompanyImage = (id) => {
  const item = SHIPPING_COMPANY.find((item) => item.value === id);
  return item?.url;
};

export const getShippingCompanyName = (id) => {
  const item = SHIPPING_COMPANY.find((item) => item.value === id);
  return item?.label ?? '-';
};

export const getTrackingLink = (shippingCompanyId, trackingNumber) => {
  switch (shippingCompanyId) {
    case 1:
      return `https://i.ghtk.vn/${trackingNumber}`;
    case 2:
      return `https://donhang.ghn.vn/?order_code=${trackingNumber}`;
    case 4:
      return `https://www.best-inc.vn/track?bills=${trackingNumber}`;
    default:
      return null;
  }
};

export const getShippingCompany = (id) => {
  return SHIPPING_COMPANY.find((item) => item.value === id);
};

export const splitOrderProductNoteLines = (note) =>
  String(note || '')
    .split(/\r?\n/)
    .filter((line) => line !== '');

export const getColorAndIconByStatusId = (statusId) => {
  let data;
  switch (statusId) {
    case 0:
      data = {
        icon: getOrderStatusIcon('all'),
        iconActive: getOrderStatusIcon('all'),
        color: '#EB5757',
      };
      break;
    case 1:
      data = {
        icon: getOrderStatusIcon('new'),
        iconActive: getOrderStatusIcon('new'),
        color: '#DE5E57',
      };
      break;
    case 2:
      data = {
        icon: getOrderStatusIcon('requestConfirmation'),
        iconActive: getOrderStatusIcon('requestConfirmation'),
        color: '#785BBC',
      };
      break;
    case 3:
      data = {
        icon: getOrderStatusIcon('confirmed'),
        iconActive: getOrderStatusIcon('confirmed'),
        color: '#4253AF',
      };
      break;
    case 4:
      data = {
        icon: getOrderStatusIcon('orderRequest'),
        iconActive: getOrderStatusIcon('orderRequest'),
        color: '#4896EC',
      };
      break;
    case 5:
      data = {
        icon: getOrderStatusIcon('ordering'),
        iconActive: getOrderStatusIcon('ordering'),
        color: '#4CAABE',
      };
      break;
    case 6:
      data = {
        icon: getOrderStatusIcon('ordered'),
        iconActive: getOrderStatusIcon('ordered'),
        color: '#52A49A',
      };
      break;
    case 7:
      data = {
        icon: getOrderStatusIcon('arrivedInStock'),
        iconActive: getOrderStatusIcon('arrivedInStock'),
        color: '#759D48',
      };
      break;
    case 8:
      data = {
        icon: getOrderStatusIcon('preparing'),
        iconActive: getOrderStatusIcon('preparing'),
        color: '#9E9C3D',
      };
      break;
    case 9:
      data = {
        icon: getOrderStatusIcon('composed'),
        iconActive: getOrderStatusIcon('composed'),
        color: '#E68538',
      };
      break;
    case 10:
      data = {
        icon: getOrderStatusIcon('packing'),
        iconActive: getOrderStatusIcon('packing'),
        color: '#52A49A',
      };
      break;
    case 11:
      data = {
        icon: getOrderStatusIcon('packed'),
        iconActive: getOrderStatusIcon('packed'),
        color: '#52A49A',
      };
      break;
    case 12:
      data = {
        icon: getOrderStatusIcon('shippedOut'),
        iconActive: getOrderStatusIcon('shippedOut'),
        color: '#C84E2A',
      };
      break;
    case 13:
      data = {
        icon: getOrderStatusIcon('delivered'),
        iconActive: getOrderStatusIcon('delivered'),
        color: '#52A49A',
      };
      break;
    case 14:
      data = {
        icon: getOrderStatusIcon('waitingForCheck'),
        iconActive: getOrderStatusIcon('waitingForCheck'),
        color: '#74574A',
      };
      break;
    case 15:
      data = {
        icon: getOrderStatusIcon('success'),
        iconActive: getOrderStatusIcon('success'),
        color: '#5AC462',
      };
      break;
    case 16:
      data = {
        icon: getOrderStatusIcon('outOfStock'),
        iconActive: getOrderStatusIcon('outOfStock'),
        color: '#667D8A',
      };
      break;
    case 17:
      data = {
        icon: getOrderStatusIcon('cancel'),
        iconActive: getOrderStatusIcon('cancel'),
        color: '#B14121',
      };
      break;
    case 18:
      data = {
        icon: getOrderStatusIcon('return'),
        iconActive: getOrderStatusIcon('return'),
        color: '#3A474E',
      };
      break;
    case 19:
      data = {
        icon: getOrderStatusIcon('return'),
        iconActive: getOrderStatusIcon('return'),
        color: '#AF6EC3',
      };
      break;
    case 20:
      data = {
        icon: getOrderStatusIcon('return'),
        iconActive: getOrderStatusIcon('return'),
        color: '#AF6EC3',
      };
      break;
    case 21:
      data = {
        icon: getOrderStatusIcon('cancel'),
        iconActive: getOrderStatusIcon('cancel'),
        color: '#D64545',
      };
      break;
    case 22:
      data = {
        icon: getOrderStatusIcon('needsAction'),
        iconActive: getOrderStatusIcon('needsAction'),
        color: '#D97706',
      };
      break;
    case 23:
      data = {
        icon: getOrderStatusIcon('packed'),
        iconActive: getOrderStatusIcon('packed'),
        color: '#52A49A',
      };
      break;
    default:
      break;
  }
  return data;
};

export const getTotalPriceOrderByStatus = (products, statusId) => {
  const totalPrice = products.reduce((prev, next) => {
    if (next.pivot.status_id === statusId || statusId === 0) {
      const price = next.pivot.payable_amount;
      prev += price;
    }
    return prev;
  }, 0);
  return formatVND(totalPrice);
};

export const getDepositType = (item) => {
  if (item.discount_percentage > 0) {
    return '(%)';
  }
  if (item.discount_amount > 0) {
    return '(đ)';
  }
  return '';
};

export const getDiscount = (item) => {
  const { price, discount_percentage, discount_amount, quantity } = item;
  let discount = 0;
  if (discount_percentage > 0) {
    discount = (price * discount_percentage) / 100;
  } else {
    discount = discount_amount / quantity;
  }
  return Math.round(discount);
};

export const getInventoryPrice = (item) => {
  const { inventory_buy_source_price, inventory_buy_original_price } = item;
  return inventory_buy_source_price - inventory_buy_original_price;
};

export const groupOrderStatus = () => {
  return [
    {
      name: 'Tất cả',
      id: 0,
      icon: getOrderStatusIcon('all'),
      iconActive: getOrderStatusIcon('all'),
      color: '#EB5757',
      childId: [],
      child: [],
      isOnlyAdmin: true,
    },
    {
      name: 'Xác nhận',
      icon: getOrderStatusIcon('requestConfirmation'),
      iconActive: getOrderStatusIcon('requestConfirmation'),
      color: '#EB5757',
      childId: [1, 2, 3, 4],
      child: [],
    },
    {
      name: 'Đặt hàng',
      icon: getOrderStatusIcon('ordered'),
      iconActive: getOrderStatusIcon('ordered'),
      color: '#EB5757',
      childId: [5, 6, 7],
      child: [],
    },
    {
      name: 'In & Đóng gói',
      icon: getOrderStatusIcon('packed'),
      iconActive: getOrderStatusIcon('packed'),
      color: '#EB5757',
      childId: [9, 10, 11, 23],
      child: [],
    },
    {
      name: 'Vận chuyển',
      icon: getOrderStatusIcon('ordering'),
      iconActive: getOrderStatusIcon('ordering'),
      color: '#EB5757',
      childId: [12, 13, 14],
      child: [],
    },
    {
      name: 'Cần xử lý',
      icon: getOrderStatusIcon('needsAction'),
      iconActive: getOrderStatusIcon('needsAction'),
      color: '#EB5757',
      childId: [17, 19, 20, 18],
    },
    {
      name: 'Thanh toán',
      icon: getOrderStatusIcon('composed'),
      iconActive: getOrderStatusIcon('composed'),
      color: '#EB5757',
      childId: [15, 16],
      isOnlyAdmin: true,
    },
    {
      name: 'Huỷ',
      icon: getOrderStatusIcon('cancel'),
      iconActive: getOrderStatusIcon('cancel'),
      color: '#EB5757',
      childId: [21, 22],
      child: [],
    },
  ];
};

export const isShowStatusQuantity = ({ item, accessPermisions }) => {
  const { isOnlyAdmin } = item;
  if (!isOnlyAdmin) {
    return true;
  }
  const { see_orders_index_tab_count } = accessPermisions;
  return see_orders_index_tab_count;
};
